import BigNumber from 'bignumber.js'
import { countDecimalPlaces, countDecimalPlacesBigNumber } from './count-decimal-places'

export function floorNumber(number: number, precision: number): number {
  return number && countDecimalPlaces(number) > precision
    ? Math.floor(number * Math.pow(10, precision)) / Math.pow(10, precision)
    : number
}

export function floorBigNumber(number: string, precision: number): string {
  if (!number?.trim() || isNaN(Number(number))) {
    return ''
  }

  const trimmed = number?.trim()
  const normalized = trimmed.startsWith('.') ? '0' + trimmed : trimmed
  const big = new BigNumber(normalized)

  return countDecimalPlacesBigNumber(normalized) > precision
    ? big.decimalPlaces(precision, BigNumber.ROUND_DOWN).toString()
    : normalized
}

export function ceilBigNumber(number: string, precision: number): string {
  if (!number?.trim() || isNaN(Number(number))) {
    return ''
  }

  const normalized = number.startsWith('.') ? '0' + number : number
  const big = new BigNumber(normalized)

  return countDecimalPlacesBigNumber(normalized) > precision
    ? big.decimalPlaces(precision, BigNumber.ROUND_CEIL).toString()
    : normalized
}

export function ceilNumber(number: number, precision: number) {
  return Math.ceil(number * Math.pow(10, precision)) / Math.pow(10, precision)
}
